<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ detailInfo.projectName }}</td>
						<th>项目编码</th>
						<td>{{ detailInfo.projectCode }}</td>
						<th>项目地址</th>
						<td>{{ detailInfo.projectAddress }}</td>
					</tr>
					<tr>
						<th>建设单位</th>
						<td>{{ detailInfo.companyName }}</td>
						<th>唯一代码</th>
						<td>{{ detailInfo.companyCode }}</td>
						<th>发生所在地市州</th>
						<td>{{ detailInfo.city }}</td>
					</tr>
					<tr>
						<th>发生所在区县</th>
						<td>{{ detailInfo.county }}</td>
						<th>不良行为分类</th>
						<td>{{ detailInfo.misconductType }}</td>
						<th>不良行为类别</th>
						<td>{{ detailInfo.misconductCategory }}</td>
					</tr>
					<tr>
						<th>不良行为代码</th>
						<td>{{ detailInfo.misconductCode }}</td>
						<th>不良行为描述</th>
						<td>{{ detailInfo.misconductDes }}</td>
						<th>处罚部门</th>
						<td>{{ detailInfo.awardDept }}</td>
					</tr>
					<tr>
						<th>处罚决定文号</th>
						<td colspan="2">{{ detailInfo.commendCode }}</td>
						<th>处罚依据</th>
						<td colspan="2">{{ detailInfo.decideContent }}</td>
					</tr>
					<tr>
						<th>处罚决定内容</th>
						<td colspan="5">{{ detailInfo.awardContent }}</td>
					</tr>
					<tr>
						<th>发布开始日期</th>
						<td>{{ detailInfo.startTime }}</td>
						<th>发布结束日期</th>
						<td>{{ detailInfo.endTime }}</td>
						<th>登记部门</th>
						<td>{{ detailInfo.registerDept }}</td>
					</tr>
					<tr>
						<th>信息来源</th>
						<td colspan="5">{{ detailInfo.source }}</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getCompanyBehaviorDetail, getCompanyPunisDetail, getCompanyWarningDetail } from '@/api/qualificationQuery/company'
	// 行政处罚详情
	export default {
		name: 'PunishmentCompanyDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			},
			// 表示是否是资质宝风险提醒
			isRisk: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				detailInfo: {},
				isVip: false,
				isSVip: false
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			if (this.isRisk) {
				this.getRiskBehaviorDetail()
			} else {
				this.initDetail()
			}
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					companyBehaviorId: this.id
				}
				getCompanyBehaviorDetail(params)
					.then(res => {
						const { data, code, message } = res
						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			// 获取资质宝风险提醒关于企业的行政处罚详情
			getRiskBehaviorDetail() {
				this.loading = true
				const params = {
					companyBehaviorId: this.id
				}

				getCompanyWarningDetail(params)
					.then(response => {
						const { data } = response
						if (data) {
							this.detailInfo = data
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
